import { Controller } from "@hotwired/stimulus"
import { setTransitionOpen } from "../helpers/transition"

export default class extends Controller {
  static targets = [
    'modal'
  ]

  show(e) {
    e.preventDefault();

    this.open(this.modalTargets[e.params.index || 0])
  }

  // Opens one of this controller's modal targets, without an action event.
  open(modal) {
    this.activeModal = modal
    // Opening an open modal would replay its enter transition.
    if (modal.open) return

    setTransitionOpen(this.activeModal, true)
    const overlay = document.querySelector('.desktop-overlay');
    if (overlay) {
      overlay.style.zIndex = 0;
    }
    // Temporarily disable sticky positioning to prevent z-index stacking issues
    document.querySelectorAll('.sticky').forEach((el) => {
      el.dataset.wasSticky = 'true';
      el.style.position = 'relative';
    });
    this.activeModal.querySelectorAll('x-transition').forEach((transition) => {
      setTransitionOpen(transition, true)
    })
  }

  hide(e) {
    e.preventDefault()

    this.hideOnly()
  }

  hideOnly() {
    const modal = this.activeModal || this.modalTarget
    modal.querySelectorAll('x-transition').forEach((transition) => {
      setTransitionOpen(transition, false)
    })
    setTransitionOpen(modal, false)

    const overlay = document.querySelector('.desktop-overlay');
    if (overlay) {
      overlay.style.zIndex = 1;
    }
    // Restore sticky positioning
    document.querySelectorAll('[data-was-sticky]').forEach((el) => {
      el.style.position = '';
      delete el.dataset.wasSticky;
    });
    this.dispatch('closed')
  }
}
